import { useNavigate } from 'react-router-dom';
import { Row, Col } from './custom';

import logo from '../images/logo.webp';

export default function Navbar()
{
    const navigate = useNavigate();

    const labels = ['solutions', 'usecase', 'samplereports'];

    function hoverOut()
    {
        const float = document.querySelector('#nav .float');

        if (float.matches(':hover')) return;

        labels.forEach((x) =>
        {
            const dropdown = float.querySelector(`.container[data-label="${x}"]`);

            dropdown.style.display = 'none';
        });
    };

    function hoverIn(E)
    {
        const target = E.target;

        const { label } = target.dataset;

        hoverOut();

        const float = document.querySelector('#nav .float');

        float.style.left = `${target.getBoundingClientRect().left}px`;

        const dropdown = float.querySelector(`.container[data-label="${label}"]`);

        float.style.display = 'flex';
        dropdown.style.display = 'flex';
    };

    return (
        <nav id = 'nav'>
            <img src={logo} alt='logo' onClick={() => navigate('/')}/>
            <span className='navItem' data-label={labels[0]} onMouseEnter={hoverIn} onMouseLeave={hoverOut}>SOLUTIONS</span>
            <span className='navItem' data-label={labels[1]} onMouseEnter={hoverIn} onMouseLeave={hoverOut}>USE CASE</span>
            <span className='navItem' data-label={labels[2]} onMouseEnter={hoverIn} onMouseLeave={hoverOut}>SAMPLE REPORTS</span>
            <span className='navItem' data-link='true' onClick={() => navigate('/perspective')}>PERSPECTIVE</span>
            <span className='navItem' data-link='true' onClick={() => navigate('/pricing')}>PRICING</span>
            <button className='contact' onClick={() => navigate('/contact')}>CONTACT US</button>
            <Row className='float' onMouseLeave={hoverOut}>
                <Col className='container' data-label={labels[0]}>
                    <span data-link='true' onClick={() => navigate('/solutions/employee-experience')}>Employee Experience</span>
                    <span data-link='true' onClick={() => navigate('/solutions/customer-experience')}>Customer Experience</span>
                    <span data-link='true' onClick={() => navigate('/solutions/secondary-research')}>Secondary Research</span>
                </Col>
                <Col className='container' data-label={labels[1]}>
                    <span data-link='true' onClick={() => navigate('/usecase/PEA')}>Predicting Employee Advocacy</span>
                    <span data-link='true' onClick={() => navigate('/usecase/DE')}>Drivers of Engagement</span>
                    <span data-link='true' onClick={() => navigate('/usecase/DEI')}>Demographic Engagement Insights</span>
                    <span data-link='true' onClick={() => navigate('/usecase/BSM')}>Brand Sentiment Monitoring</span>
                    <span data-link='true' onClick={() => navigate('/usecase/DCS')}>Drivers of Customer Satisfaction</span>
                    <span data-link='true' onClick={() => navigate('/usecase/PCA')}>Predicting Customer Advocacy</span>
                    <span data-link='true' onClick={() => navigate('/usecase/OCC')}>Optimizing Choices with Conjoint</span>
                    <span data-link='true' onClick={() => navigate('/usecase/DIS')}>Demographic Impact on Satisfaction</span>
                    <span data-link='true' onClick={() => navigate('/usecase/ATU')}>ATU in Pharma</span>
                    <span data-link='true' onClick={() => navigate('/usecase/MRT')}>Message Recall Testing</span>
                </Col>
                <Col className='container' data-label={labels[2]}>
                    <span data-link='true' onClick={() => navigate('/sample/EJI')}>Employee Journey Insights</span>
                    <span data-link='true' onClick={() => navigate('/sample/CX')}>CX Trends and Insights</span>
                    <span data-link='true' onClick={() => navigate('/sample/MII')}>Market Intelligence Insights</span>
                </Col>
            </Row>
        </nav>
    );
}